import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface CheckActivePictoProps extends pictoProps {
}

export interface CheckActivePictoState extends pictoState {
}

export class CheckActivePicto extends Picto<CheckActivePictoProps,CheckActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.checkActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(CheckActivePicto);
